import React from "react";
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from "react-router-dom";

import { useAuth } from "../hooks/auth";
import AuthLayout from "../styles/AuthLayout";
import DefaultLayout from "../styles/DefaultLayout";

interface IRouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<IRouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  if (user && !isPrivate) {
    return <Redirect to="/" />;
  }

  if (!user && isPrivate) {
    return <Redirect to="/sign-in" />;
  }

  const Layout = isPrivate ? DefaultLayout : AuthLayout;

  return (
    <Layout>
      <ReactDOMRoute {...rest} render={() => <Component />} />
    </Layout>
  );
};

export default Route;
